import { call, put, select, takeLatest } from 'redux-saga/effects';

import discountService from 'services/discountsService';

import { getGroupId } from 'store/session/selectors';

import { createDiscount, entities, types } from './actions';

export default function* root() {
  yield takeLatest(types.CREATE_DISCOUNT_REQUEST, watchCreateDiscount);
}

function* watchCreateDiscount(action) {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(
      discountService.create,
      groupId,
      action.payload,
    );
    yield put(createDiscount.success({ discount: response }));
  } catch (error) {
    yield put(createDiscount.error(error));
  }
}

export function* initDiscountsListPage() {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(discountService.list, groupId);
    yield put(entities.recieveDiscountDefs({ discountDefs: response }));
  } catch (error) {
    console.error('ERROR WHEN FETCHING DISCOUNTS', error);
  }
}
